import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart } from 'react-chartjs-2';

const ExpenseChart = ({ revBal, InsBal, limit }) => {
  const data = {
    labels: ['Total Revolving Balances', 'Total Installment Balances', 'Total Limits'],
    datasets: [
      {
        label: 'Debt to Limits Ratio',
        data: [revBal, InsBal, limit],
        backgroundColor: ['rgba(54, 162, 235, 0.2)', 'rgba(255, 206, 86, 0.2)', 'rgba(75, 191, 115,0.2)'],
        borderColor: ['rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 191, 115,1)'],
        borderWidth: 1,
        borderRadius: 10,
      },
    ],
  };

  const options = {
    responsive: true,
    devicePixelRatio: window.devicePixelRatio,
    cutout: '-50%',
    legend: {
      display: true,
    },
    layout: {
      // padding: {
      //   left: 20,
      //   right: 20,
      //   top: 20,
      //   bottom: 20,
      // },
    },
  };
  const chartRef = React.useRef(null);

  React.useEffect(() => {
    if (chartRef && chartRef.current) {
      const newChartInstance = new Chart(chartRef.current, {
        type: 'doughnut',
        data: data,
        options: options,
      });
    }
  }, [chartRef]);

  return (
    <div style={{ width: 500 }}>
      <canvas ref={chartRef} />
    </div>
  );
};

export default ExpenseChart;
